import { Configuration } from "node-library/dist/portal";

const Config: Configuration = {
	host: process.env.REACT_APP_API_HOST,
	port: process.env.REACT_APP_API_PORT,
	frontendBaseUrl: process.env.REACT_APP_API_HOST,
	appVersion: process.env.REACT_APP_VERSION,
};

export default Config;
